import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'
import { ViewableBy } from '../utilities/viewable-check'

export const ButtonBlockFragment: BlockFragment = {
  name: 'button',
  fragment: gql`
    fragment button on Button {
      id
      blockName
      blockType
      label
      link
      buttonAlignment: alignment
      buttonMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on Button {
      id
      blockName
      blockType
      label
      link
      buttonAlignment: alignment
      buttonMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const ButtonBlockType = 'button'

export interface ButtonBlock extends BaseBlock {
  blockType: typeof ButtonBlockType
  label: string
  link: string
  buttonAlignment: 'left' | 'center' | 'right'
  buttonMeta?: {
    viewableBy: [ViewableBy]
  }
}
